"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAuthToken = exports.setAuthToken = exports.feedFactoryAxios = void 0;
const axios_1 = __importDefault(require("axios"));
const myAxios = axios_1.default.create({
    baseURL: "/api",
});
exports.feedFactoryAxios = myAxios;
const setAuthToken = (authToken) => {
    exports.feedFactoryAxios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
};
exports.setAuthToken = setAuthToken;
const resetAuthToken = () => {
    exports.feedFactoryAxios.defaults.headers.common["Authorization"] = null;
};
exports.resetAuthToken = resetAuthToken;
//# sourceMappingURL=feedFactoryAxios.js.map